import { baseUrl, headers, jwtHeaders, logoutUtil } from '../common/data';

export const fetchAllBillingAndMsgStatus = async (data) => {
  const queryParams = new URLSearchParams(data).toString();
  const url = `${baseUrl}/api/superadminreports/getbillingcountandmsgcount?${queryParams}`;

  const response = await fetch(url, {
    method: 'POST',
    headers: jwtHeaders(),
    redirect: 'follow',
  });

  if (response?.status === 401) {
    logoutUtil();
  }
  const resData = await response?.json();

  return resData;
};

export const fetchtotalbillamount = async (data) => {
  const queryParams = new URLSearchParams(data).toString();
  const url = `${baseUrl}/api/superadminreports/totalbillamount?${queryParams}`;

  const response = await fetch(url, {
    method: 'POST',
    headers: jwtHeaders(),
    redirect: 'follow',
  });

  if (response?.status === 401) {
    logoutUtil();
  }
  const resData = await response?.json();

  return resData;
};

export const fetchexpiringbranch = async (data) => {
  const queryParams = new URLSearchParams(data).toString();
  const url = `${baseUrl}/api/superadminreports/expiringbranch?${queryParams}`;

  const response = await fetch(url, {
    method: 'POST',
    headers: jwtHeaders(),
    redirect: 'follow',
  });

  if (response?.status === 401) {
    logoutUtil();
  }
  const resData = await response?.json();

  return resData;
};
export const fetchLatestSubscriptionUpdateBranch = async (data) => {
  const queryParams = new URLSearchParams(data).toString();
  const url = `${baseUrl}/api/superadminreports/getlatestsubscriptoinupdatebranch?${queryParams}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: jwtHeaders(),
    redirect: 'follow',
  });

  if (response?.status === 401) {
    logoutUtil();
  }
  const resData = await response?.json();

  return resData;
};